// extracted by mini-css-extract-plugin
export default {"blender_bottle_item":"pJ","blender_bottle_img":"qJ","blender_bottle_info":"rJ","blender_bottle_title":"sJ","blender_bottle_bold":"tJ","blender_bottle_usual":"uJ","blender_bottle_item_mob":"vJ","addbutton":"wJ","blender_bottle_title_mob":"xJ","blender_bottle_bold_mob":"yJ","blender_bottle_usual_mob":"zJ","bolder":"AJ","bottom_margin_4":"BJ","bottom_margin_16":"CJ"};
    if(module.hot) {
      // 1743628927316
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  